import ENDPOINT from '../../../constants/endpoints';
import createApiTypes from '../../../services/helpers/api-types';

export const UserConst = {
  GET: createApiTypes('GET_USER'),
  SIGN_IN: createApiTypes('SIGN_IN_USER'),
  USER_UPDATE_RESUME: 'USER_UPDATE_RESUME',
  USER_UPDATE_POPUPS: 'USER_UPDATE_POPUPS',
  USER_UPDATE_PICTURE: 'USER_UPDATE_PICTURE',
  USER_UPDATE_INBOX_COUNT: 'USER_UPDATE_INBOX_COUNT',
  USER_UPDATE_INBOUNDS_COUNT: 'USER_UPDATE_INBOUNDS_COUNT',
  USER_UPDATE_OPTION: createApiTypes('USER_UPDATE_OPTION'),
  USER_UPDATE_PERMISSION: createApiTypes('USER_UPDATE_PERMISSION'),

  USER_SET_OPTION: 'USER_SET_OPTION',
  USER_SET_PERMISSION: 'USER_SET_PERMISSION',
};

export const User = {
  uploadResume() {
    return {
      type: UserConst.USER_UPDATE_RESUME,
    };
  },

  uploadPopups(popups) {
    return {
      type: UserConst.USER_UPDATE_POPUPS,
      payload: popups,
    };
  },

  updatePicture(picture) {
    return {
      type: UserConst.USER_UPDATE_PICTURE,
      payload: picture,
    };
  },

  updateInboxCount(count) {
    return {
      type: UserConst.USER_UPDATE_INBOX_COUNT,
      payload: count,
    };
  },

  updateInboundsCount(count) {
    return {
      type: UserConst.USER_UPDATE_INBOUNDS_COUNT,
      payload: count,
    };
  },

  get() {
    return {
      type: UserConst.GET.TYPE,
      tag: {},
      meta: {
        type: 'api',
        options: {
          method: 'get',
          url: ENDPOINT.OTHER.USER_STATE,
        },
      },
    };
  },

  signIn(params, options) {
    return {
      type: UserConst.SIGN_IN.TYPE,
      tag: {
        params: {
          ...params,
        },
        options: {
          ...options,
        },
      },
      meta: {
        type: 'api',
        options: {
          method: 'post',
          url: ENDPOINT.OTHER.USER_LOGIN,
          params: {
            ...params,
          },
        },
      },
    };
  },

  updateUserOption(option, value = null) {
    return value === null
      ? {
          type: UserConst.USER_UPDATE_OPTION.TYPE,
          tag: {},
          meta: {
            type: 'api',
            options: {
              method: 'get',
              url: ENDPOINT.OTHER.USER_STATE_OPTION,
              params: { option },
            },
          },
        }
      : {
          type: UserConst.USER_SET_OPTION,
          payload: { [option]: value },
        };
  },

  updateUserPermission(permission, value = null) {
    return value === null
      ? {
          type: UserConst.USER_UPDATE_PERMISSION.TYPE,
          tag: {},
          meta: {
            type: 'api',
            options: {
              method: 'get',
              url: ENDPOINT.OTHER.USER_STATE_PERMISSION,
              params: { permission },
            },
          },
        }
      : {
          type: UserConst.USER_SET_PERMISSION,
          payload: { [permission]: value },
        };
  },
};
